import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col w-full h-max"
}
const _hoisted_2 = { class: "flex flex-col w-full p-4 mb-4 bg-gray-50 rounded" }
const _hoisted_3 = { class: "ml-2 mb-2 text-lg uppercase font-bold text-black" }
const _hoisted_4 = { class: "text-sm font-normal text-gray-500 lowercase" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_multiselect = _resolveComponent("vue-multiselect")!
  const _component_proposal_suppliers_form_section = _resolveComponent("proposal-suppliers-form-section")!
  const _component_section_button = _resolveComponent("section-button")!
  const _component_spinner = _resolveComponent("spinner")!

  return (_ctx.suppliersChoices?.availableSuppliers !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t('proposal.suppliers.modal_form.fields_labels.country_filter')) + " ", 1),
            _createElementVNode("span", _hoisted_4, " (" + _toDisplayString(_ctx.$t('proposal.suppliers.modal_form.fields_labels.optional')) + ") ", 1)
          ]),
          _createVNode(_component_vue_multiselect, {
            options: _ctx.allCountriesOptions,
            id: "global-country-filter",
            label: "name",
            "track-by": "id",
            "close-on-select": false,
            multiple: true,
            limit: 4,
            placeholder: "Select countries to filter suppliers...",
            modelValue: _ctx.selectedCountries,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCountries) = $event)),
              _ctx.countryFilterChanged
            ]
          }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suppliersChoices.suppliers, (section, index) => {
            return (_openBlock(), _createBlock(_component_proposal_suppliers_form_section, {
              "section-data": section,
              index: index as number,
              key: index
            }, null, 8, ["section-data", "index"]))
          }), 128))
        ]),
        _createVNode(_component_section_button, {
          class: "w-max mx-auto",
          onClick: _ctx.addNewSection
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('proposal.suppliers.modal_form.add_button')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createVNode(_component_spinner)
      ]))
}